import React from 'react';
import styles from '../styles/ProtectedRoute.module.css';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole, requiredPermission }) => {
  const { user, token, can, permissionsReady } = useAuth();

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && !requiredRole.includes(user.role)) {
    return (
      <div className={styles.accessDenied}>
        <h1>Access Denied</h1>
        <p>You don't have permission to access this page.</p>
      </div>
    );
  }

  if (requiredPermission && !permissionsReady) {
    return null;
  }

  if (requiredPermission && !can(requiredPermission.module, requiredPermission.action || 'view')) {
    return (
      <div className={styles.accessDenied}>
        <h1>Access Denied</h1>
        <p>You don't have permission to access this page.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
